import {createSlice} from '@reduxjs/toolkit';

// ==============================|| REDUX - MAIN STORE ||============================== //

const Payroll = createSlice({
    name: 'payroll',
    initialState: {
        transaction_id: '',
        PayrollData: '',
        allEmployees: [],
        EmployeeMsg: '',
        isLoading: false,
        payrollModal: false,
        isCreating: false,
        employeeModal: false,
        User: '',
        isLogIn: false,
        logInMsg: '',
        payrolFailMessage: '',
        loginModal: false,
        Step: 1,
        setUpSuccess: false,
        payrollStatus: false,
        payrollOptionParameters: false,
        payrolFailModal: false,
        payrollItem_Id:'',
        CreatedEmployeeDetails:'',
        EmployeeDetails:{
            Bio:false,
            NextOfKin:false,
            Identify:false,
            Info:false,
            Health:false,
            Review:false,
        },
        Personal:'',
        Employment:'',
        Career:'',
        Contact:'',
        Time:'',
        Salary:'',
        EmployeeDetailStatus:{
            PersonalStatus:false,
            EmploymentStatus:false,
            CareerStatus:false,
            ContactStatus:false,
            TimeStatus:false,
            SalaryStatus:false,
        },
        BusinessRules:'',
        CareerHistory:[],
        PayrollDetails:'',
        Proxy: {
            status: false,
            id: ''
        },
        UpdatedDetail: {}
    },
    reducers: {
        GetPayroll:(state,action)=>{
            state.PayrollDetails=action.payload
        },
        GetCareerHistory:(state,action)=>{
            state.CareerHistory.push(action.payload)
        },
        GetRules:(state,action)=>{
            state.BusinessRules=action.payload
        },
        GetCreatedEmployeeDetail:(state,action)=>{
            state.CreatedEmployeeDetails=action.payload
        },
        GetPersonal:(state,action)=>{
            state.Personal=action.payload
        },
        GetEmployment:(state,action)=>{
            state.Employment=action.payload
        },
        GetCareer:(state,action)=>{
            state.Career=action.payload
        },
        GetContact:(state,action)=>{
            state.Contact=action.payload
        },
        GetTime:(state,action)=>{
            state.Time=action.payload
        },
        GetSalary:(state,action)=>{
            state.Salary=action.payload
        },
        SetEployeeDetails:(state,action)=>{
            state.EmployeeDetails=action.payload
        },
        SetEmployeeDetailStatus:(state,action)=>{
            state.EmployeeDetailStatus=action.payload
        },
        fetchOptionParams: (state, action) => {
            state.payrollOptionParameters = action.payload
        },
        GetPayroll_Id:(state,action)=>{
            state.payrollItem_Id=action.payload
        },
        fetchPayrollStatus: (state, action) => {
            state.payrollStatus = action.payload
        },
        fetchPayrollfailModal: (state, action) => {
            state.payrolFailModal = action.payload
        },
        fetchPayrollFailsms: (state, action) => {
            state.payrolFailMessage = action.payload
        },
        Logmsg: (state, action) => {
            state.logInMsg = action.payload
        },
        authSetUp(state, action) {
            state.setUpSuccess = action.payload
        },
        logModal: (state, action) => {
            state.loginModal = action.payload
        },
        authLogin: (state, action) => {
            state.isLogIn = action.payload
        },
        fetchEmployee: (state, action) => {
            state.allEmployees = action.payload
        },
        CreateEmployee(state, action) {
            state.EmployeeMsg = action.payload
        },
        fetchPayroll: (state, action) => {
            state.PayrollData = action.payload
        },
        loading(state, action) {
            state.isLoading = action.payload
        },
        loadingModal(state, action) {
            state.payrollModal = action.payload
        },
        creatingLoading(state, action) {
            state.isCreating = action.payload
        },
        employeeModalLoading(state, action) {
            state.employeeModal = action.payload
        },
        getUser(state, action) {
            state.User = action.payload
        },
        StepTab(state, action) {
            state.Step = action.payload
        },
        fetchId(state, action) {
            state.transaction_id = action.payload
        },
        updateProxy(state, action) {
            state.Proxy = action.payload
        },
        updateDetail(state, action) {
            state.UpdatedDetail = action.payload
        }

    }
});

export const payrollActions = Payroll.actions

export default Payroll.reducer

// const store = createStore(reducer);
// const persister = 'Free';

// export { store, persister };
